import { StorageService } from 'services/storage-service/StorageService';
import { StorageBase } from 'services/storage-service/StorageBase';

class StorageServiceImpl extends StorageBase implements StorageService {
	deleteAllStorage(typeStorage: Storage): void {
		typeStorage.clear();
	}

	deleteKey(key: string, typeStorage: Storage) {
		typeStorage.removeItem(key);
	}

	getFromStoreObject(
		keyStorage: string,
		keyObject: string,
		typeStorage: Storage
	): number | string | object | boolean |null {
		let response: null;
		const objResponse = this.getObject(keyStorage, typeStorage);
		if (objResponse && objResponse.hasOwnProperty(keyObject)) {
			response = objResponse[keyObject];
		} else {
			response = null;
		}
		return response;
	}

	setToStoreObject(
		keyStorage: string,
		objectStorage: Record<string, any>,
		typeStorage: Storage
	): boolean {
		const objResponse = JSON.parse(this.getData(keyStorage, typeStorage) || '{}');
		for (let key in objectStorage) {
			objResponse[key] = objectStorage[key];
		}
		return this.createObject(keyStorage, objResponse, typeStorage);
	}

	deleteItemOnStoreObject(keyStorage: string, keyObject: string, typeStorage: Storage): boolean {
		return this.deleteObjectAttribute(keyStorage, keyObject, typeStorage);
	}

	getAllFromStoreObject(keyStorage: string, typeStorage: Storage) {
		return this.getObject(keyStorage, typeStorage) ? this.getObject(keyStorage, typeStorage) : {};
	}
}
export { StorageServiceImpl };
